export default __webpack_public_path__ + "static/media/calendar.15165ea6.svg";